export const searchStyles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px',
  },
  searchBarInput: {
    width: '100%',
    marginBottom: { xs: '20px', sm: '0' },
  },
};
